import { ModifyIdentity } from '@grid/models';
import { DprHseDetail } from '@shared/models/dpr';

export interface DprHseDetailGridData extends ModifyIdentity<DprHseDetail> {
  priority: number;
  name: string;
  total: number;
}
